enum CookiesEnum {
  CurrencyId = 'mm_currency_id',
  AuthLongTermSessionToken = 'session_token',
  QuoteTrackSetDelivery = 'qu_track_10',
  QuoteTrackSetPayment = 'qu_track_20',
  QuoteTrackClickPay = 'qu_track_40',
  QuoteTrackPaymentSuccess = 'qu_track_50',
  CanCheckTranslations = 'can_check_translations',
  CanViewTranslations = 'can_view_translations',
}

export default CookiesEnum
